
import { mapState } from 'vuex'
export default {
  inject: ['detail'],
  data() {
    return {
      widthType: 'pc',
      moreinfo: {}
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      contentcookie: 'contentcookie'
    }),
    // 获取年龄，性别，薪酬信息
    InfoArr() {
      const bs = this.detail?.basicInfo

      if (bs?.yearBorn || bs?.gender > 0 || bs?.salary) {
        const col = []
        if (bs?.yearBorn && bs?.yearBorn != '--') {
          col.push({
            name: this.$v('出生年份'),
            value: bs?.yearBorn
          })
        }
        if (bs?.gender > 0) {
          col.push({
            name: this.$v('性别'),
            value: bs?.gender == 2 ? this.$t('21540') : this.$t('21539')
          })
        }
        if (bs?.salary && bs?.salary != '--') {
          col.push({
            name: this.$v('薪酬'),
            value: bs?.salary
          })
        }
        return col
      } else {
        return null
      }
    }
  },
  mounted() {
    this.getelewidth()
    console.log('detail-basicinfo')
  },
  methods: {
    getelewidth() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth()) this.widthType = 'pc'
      else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth()) this.widthType = 'lg'
      else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth()) this.widthType = 'md'
      else this.widthType = 'sm'
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    }
  }
}
